import {
  useFacilityRevisionStream,
  type UseCourtStateStreamOptions,
} from "./useCourtStateStream";

const RESERVATION_RECONCILE_INTERVAL_MS = 1_000;

const reservationStatePath = (facilityId: string, revision: number): string =>
  `/bff/api/facilities/${encodeURIComponent(facilityId)}` +
  "/reservation-state/events" +
  `?after_revision=${revision}`;

/**
 * Subscribe to the reservation-only durable cursor.
 *
 * Reconciliations are canonical REST reads bounded to one per second under
 * sustained occupancy changes. End-to-end propagation is measured separately by
 * the two-client Playwright journey, from mutation completion to canonical DOM.
 */
export function useReservationStateStream(
  options: UseCourtStateStreamOptions,
): void {
  useFacilityRevisionStream({
    ...options,
    channelName: "reservation-state",
    eventName: "reservation-state",
    path: reservationStatePath,
    minimumReconcileIntervalMs: RESERVATION_RECONCILE_INTERVAL_MS,
  });
}
